export { ConsoleListener } from './src/index.es';



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-instrumentation/packages/console-listener/index.es